// @flow
import React from 'react';

import Box from '@waglabs/box';

import { HowItWorks as HowItWorksBlock } from '../../../HowItWorks';

const HOW_IT_WORKS_DATA = [
  {
    icon: 'oneShelter',
    headingText: 'Peace of mind',
    text: 'We believe that every dog should be safe, so Wag! Tag is completely free to rescue pups — no strings or obligations. Pet parents scan the QR code (or enter the URL) and follow the easy steps to create an online profile for their new furry family member.',
  },
  {
    icon: 'twoShelter',
    headingText: 'Personalized profile',
    text: 'Going further than a traditional tag, Wag! Tag gives pet parents a chance to add the safety info they’d want someone to know about their dog, including emergency contacts, secure drop-off locations, allergies, vaccinations, and behavioral notes.',
  },
  {
    icon: 'threeShelter',
    headingText: 'Speedy reunions',
    text: 'Once a dog is found, the hero can easily scan the Wag! Tag with any smartphone to instantly access pet parent contact information and alert the owner that their pup has been found.',
  },
];

export const HowItWorks = () => (
  <Box
    py={[4, 4, '100px']}
  >
    <HowItWorksBlock
      data={HOW_IT_WORKS_DATA}
      sectionTitle="What Wag! Tag gives pet families"
    />
  </Box>
);
